import { useEffect, useState } from "react";


import { useFetchQuotationContext } from "context/QuotationListContext";
import { t } from "i18next";
import { Link } from "react-router-dom";

// Define an array of links

const QuotationList = () => {
  const { getQuotations, loading, quotations, deleteQuotation } =
    useFetchQuotationContext();

  useEffect(() => {
    getQuotations();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  const [sortField, setSortField] = useState("date");
  const [sortDirection, setSortDirection] = useState("desc");

  const handleSort = (field: string) => {
    if (sortField === field) {
      setSortDirection(sortDirection === "asc" ? "desc" : "asc");
    } else {
      setSortField(field);
      setSortDirection("asc");
    }
  };

  const handleDelete = async (id: string, name: string, email: string) => {
    await deleteQuotation(id, name, email);
  };

  const sortedLinks = [...quotations].sort((a, b) => {
    const aValue = a[sortField as keyof typeof a];
    const bValue = b[sortField as keyof typeof b];

    if (aValue && bValue) {
      if (aValue < bValue) {
        return sortDirection === "asc" ? -1 : 1;
      } else if (aValue > bValue) {
        return sortDirection === "asc" ? 1 : -1;
      } else {
        return 0;
      }
    } else {
      return 0;
    }
  });

  const sortIndicator = (field: string) => {
    if (sortField !== field) return "";
    return sortDirection === "asc" ? " \u2191" : " \u2193";
  };

  // Render the links as a table
  return (
    <div className="page">
      <div className="page-breadcrumb">
        <Link to="/">{t("home")}</Link>
        <span className="breadcrumb-separator">/</span>
        <span className="breadcrumb-current">{t("listOfQuotations")}</span>
      </div>

      <div className="page-header">
        <h1>{t("listOfQuotations")}</h1>
        <button className="edit-button" onClick={() => getQuotations(true)}>
          {t("refresh")}
        </button>
      </div>
      {loading && <div>{t("loading")}</div>}
      <table className="quotation-table">
        <thead>
          <tr>
            <th onClick={() => handleSort("name")} style={{ cursor: 'pointer' }}>{t("name")}{sortIndicator("name")}</th>
            <th onClick={() => handleSort("email")} style={{ cursor: 'pointer' }}>{t("email")}{sortIndicator("email")}</th>
            <th onClick={() => handleSort("date")} style={{ cursor: 'pointer' }}>{t("dateCreated")}{sortIndicator("date")}</th>
            <th onClick={() => handleSort("createdBy")} style={{ cursor: 'pointer' }}>{t("createdBy")}{sortIndicator("createdBy")}</th>
            <th onClick={() => handleSort("province")} style={{ cursor: 'pointer' }}>{t("province")}{sortIndicator("province")}</th>
            <th>{t("notes")}</th>
            <th>{t("delete")}</th>
          </tr>
        </thead>
        <tbody>
          {sortedLinks.map((link) => (
            <tr key={link.id}>
              <td>
                <Link to={`/quotations/${link.id}`}>
                  {link.name || t("noName")}
                </Link>
              </td>
              <td>{link.email}</td>
              <td>{new Date(link.date.seconds * 1000).toLocaleDateString()}</td>
              <td>{link.createdBy}</td>
              <td>{link.province}</td>
              <td>{link.note}</td>
              <td>
                <button
                  className="btn-destructive"
                  onClick={() => handleDelete(link.id, link.name, link.email)}
                >
                  {t("delete")}
                </button>
              </td>
            </tr>
          ))}
        </tbody>
      </table>
    </div>
  );
};

export default QuotationList;
